import { getUrl } from 'helpers';
import styled from 'styled-components';

export const Container = styled.div<LandingContainerProps>`
    align-items: stretch;
    background-image: url('${({ $backgroundImage }) => getUrl($backgroundImage)}');
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    color: #ffffff;
    display: flex;
    flex-direction: column;
    flex: 1;

    @media (min-width: 1200px) {
        flex-direction: row;
    }
`;

export const Left = styled.div<LandingLeftProps>`
    align-items: center;
    display: flex;
    flex-direction: ${({ $split }) => ($split ? 'row-reverse' : 'column')};
    gap: 8px;
`;

export const LeftContent = styled.div<LandingLeftContentProps>`
    flex: ${({ $center }) => ($center ? 0 : 1)};
    text-align: ${({ $center }) => ($center ? 'center' : 'left')};
`;

export const Right = styled.div`
    background-color: rgba(30, 30, 30, 0.4);
    flex: 1;
    padding: 40px 60px;

    @media (min-width: 1200px) {
        max-width: 570px;
    }
`;

export const Points = styled.div`
    align-items: center;
    column-gap: 10px;
    display: grid;
    grid-template-columns: 36px 1fr;
    row-gap: 16px;
`;

export const Arrow = styled.div`
    position: absolute;
    left: -90px;
    top: -10px;
    transform: rotate(40deg);
`;
